
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./styles.css";
import Header from "./Header";
import Map from "./Map";
import MapHome from "./MapHome";
import ArtistList from "./ArtistList";
import ArtistPage from "./ArtistPage";
import WorldMapSvg from "./WorldMapSvg";
// Original App component content
function OriginalApp() {
  return (
    <div className="App app-original relative">
      <Header />
      <div className="map-container">
      <WorldMapSvg />
      </div>
      <div className="artist-list-container">
      <div className="artist-list-header">
        <p className="artist-list-subtitle">Join us every week for a new one-hour curated mix by artists and creatives from around the world.</p>
      </div>
      </div>
      <ArtistList />
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/world-map" element={<WorldMapSvg />} />
        <Route path="/" element={<OriginalApp />} />
        <Route path="/map-home" element={<MapHome />} />
        <Route path="/artists" element={<ArtistList />} />
        <Route path="/artist/:id" element={<ArtistPage />} />
      </Routes>
    </Router>
  );
}
